/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Missing_Dialogue_TitleInputs */



/**
* | output |
* | --- |
* | "Missing Dialogue" |
*
* @param {Missing_Dialogue_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const missing_dialogue_title = /** @type {((inputs?: Missing_Dialogue_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missing_Dialogue_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dialogue manquant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlender Dialog")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dialogo mancante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отсутствующий диалог")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diálogo faltante")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缺失对话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("会話がない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद गायब है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diálogo Ausente")
	return /** @type {LocalizedString} */ ("Missing Dialogue")
});